import * as React from "react";
import {connect} from 'react-redux';
import {
  getInvoiceQuery,
} from './Selectors';
import _ from 'lodash';
import {getInvoices, setSelectedSoldTos, updateSecondaryAccounts} from '../../actions/InvoiceActions';
import {withRouter} from "react-router-dom";
import {useState} from "react";
import {useEffect} from "react";
import * as appConstants from "../../constants/ApplicationConstants";
import {getSoldToNames} from "../../requests/InvoiceRequests";
import {usePrevious} from "../../hooks";

export const InvoicesContext = React.createContext([]);

function computeSoldToSelectAll(invoices, dispatch) {
  let soldTos = invoices.map(invoice => invoice.soldto_number);
  soldTos = soldTos.filter((soldTo, pos) => soldTos.indexOf(soldTo) === pos);
  // If we have zzcustom soldtoad use the soldto for that data. 
  if (invoices.length > 0 && invoices[0].zzcustom && invoices[0].zzcustom.soldtoad) {
    let listSet = {};
    invoices.forEach(invoice => {
      listSet[invoice.soldto_number] = {
        PrimaryAcct: invoice.soldto_number,
        Name: invoice.zzcustom.soldtoad.name,
      }
    });
    dispatch(setSelectedSoldTos(soldTos));
    updateSecondaryAccounts(dispatch, Object.values(listSet));
  } else {
    getSoldToNames(soldTos).then((soldTosResults) => {
      let list = [];
      for (let prop in soldTosResults) {
        list.push({
          PrimaryAcct: prop,
          Name: soldTosResults[prop],
        });
      }
      dispatch(setSelectedSoldTos(soldTos));
      updateSecondaryAccounts(dispatch, list);
    });
  }
}

function InvoiceDataManager(props) {

  const [invoices, setInvoices] = useState([]);

  let invoiceSearchQuery = props.invoiceSearchQuery;
  let forceRefresh = props.forceRefresh;

  const prev = usePrevious({invoiceSearchQuery, forceRefresh});

  useEffect(() => {
    if (props.invoiceSearchQuery !== null ) {
      if(typeof prev === "undefined" ||!_.isEqual(prev.invoiceSearchQuery, invoiceSearchQuery) || prev.forceRefresh !== forceRefresh ){
        getInvoices(props.dispatch, props.invoiceSearchQuery).then(([invoices, _]) => {
          if (props.accountType === appConstants.ACCOUNT_PAYER_ALL) {
            computeSoldToSelectAll(invoices, props.dispatch);
          }
        });
      }
    }
  }, [
    props.invoiceSearchQuery,
    props.forceRefresh
  ]);

  useEffect(() => {
    setInvoices(props.invoices);
  }, [
    props.invoices,
  ]);

  return <InvoicesContext.Provider value={invoices}>{props.render}</InvoicesContext.Provider>;
}

export default withRouter(connect((state, props) => {
  return {
    accountType: state.user_options.accountType,
    invoiceSearchQuery: getInvoiceQuery(state, props),
    invoices: state.default.invoices,
    forceRefresh: state.invoice.forceRefresh,
  };
})(InvoiceDataManager));
